module.exports = __webpack_public_path__ + "img/block2-5.4d39e4c7.svg";